(() => {
  const selector = 'img, a';
  const batchSize = 50;
  const settings = document.currentScript?.dataset || {};
  const queue = new Set();
  let scheduled = false;
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const addImageTitle = (image) => {
    if (!clean(image.getAttribute('alt')) && /(?:^|\/)SE_flag\.(?:gif|png|webp|avif|svg)(?:[?#]|$)/i.test(image.getAttribute('src') || '') && settings.flagAlt) image.setAttribute('alt', settings.flagAlt);
    if (clean(image.getAttribute('title'))) return;
    let title = clean(image.getAttribute('alt'));
    if (!title) {
      const card = image.closest('.product-card-wrapper, .card-wrapper, .pooltime-collection-card, .cart-item');
      title = clean(card?.querySelector('.card__heading, .pooltime-collection-card__title, .cart-item__name')?.textContent);
    }
    if (!title) {
      const link = image.closest('a');
      title = clean(link?.getAttribute('aria-label') || link?.getAttribute('title') || link?.textContent);
    }
    title ||= clean(document.querySelector('h1')?.textContent) || clean(document.title);
    if (title) image.setAttribute('title', title);
  };
  const addLinkTitle = (link) => {
    if (clean(link.getAttribute('title'))) return;
    const href = clean(link.getAttribute('href'));
    let title = clean(link.getAttribute('aria-label')) || clean(link.textContent);
    if (!title) {
      const image = link.querySelector('img');
      title = clean(image?.getAttribute('alt') || image?.getAttribute('title'));
    }
    if (/^mailto:/i.test(href)) title = (settings.emailTitle || '[address]').replace('[address]', href.slice(7).split('?')[0]);
    else if (/^tel:/i.test(href)) title = (settings.phoneTitle || '[number]').replace('[number]', href.slice(4));
    if (!title) {
      if (href === '/') title = settings.homeTitle;
      else if (href.includes('quotePopup')) title = settings.quoteTitle;
      else if (!href || href.startsWith('#') || /^javascript:/i.test(href)) title = settings.menuTitle;
      else title = href.split('?')[0].split('#')[0];
    }
    title = clean(title || settings.openTitle || document.title).slice(0, 200);
    if (title) link.setAttribute('title', title);
  };
  const addTitle = (element) => {
    if (element.matches('img')) addImageTitle(element);
    else if (element.matches('a')) addLinkTitle(element);
  };
  const collect = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) queue.add(node);
    node.querySelectorAll(selector).forEach((image) => queue.add(image));
  };
  const schedule = () => {
    if (scheduled || !queue.size) return;
    scheduled = true;
    if ('requestIdleCallback' in window) requestIdleCallback(flush, { timeout: 1000 });
    else setTimeout(flush, 0);
  };
  const flush = (deadline) => {
    scheduled = false;
    let processed = 0;
    for (const element of queue) {
      queue.delete(element);
      if (element.isConnected) addTitle(element);
      processed += 1;
      if (processed >= batchSize || (processed > 0 && deadline && !deadline.didTimeout && deadline.timeRemaining() < 2)) break;
    }
    schedule();
  };
  const start = () => {
    collect(document.body);
    schedule();
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') queue.add(record.target);
        else record.addedNodes.forEach(collect);
        const link = record.target.closest?.('a') || record.target.parentElement?.closest('a');
        if (link) queue.add(link);
      });
      schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'src', 'href', 'aria-label'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
